import { apiRequest } from "./client";

export function listFowebPortalWatches(author) {
  const name = String(author || "").trim();
  const query = name ? `?author=${encodeURIComponent(name)}` : "";
  return apiRequest(`/fowebportalwatches${query}`);
}

export function createFowebPortalWatch(body) {
  return apiRequest("/fowebportalwatches", { method: "POST", body });
}

export function updateFowebPortalWatch(id, body) {
  return apiRequest(`/fowebportalwatches/${id}`, { method: "PUT", body });
}

export function deleteFowebPortalWatch(id) {
  return apiRequest(`/fowebportalwatches/${id}`, { method: "DELETE" });
}

export async function uploadFowebPortalWatchMedia(id, files) {
  const list = Array.from(files || []);
  const added = [];
  let last;
  for (const file of list) {
    const body = new FormData();
    body.append("files", file);
    last = await apiRequest(`/fowebportalwatches/${id}/media`, { method: "POST", body });
    if (Array.isArray(last?.added)) added.push(...last.added);
  }
  return { ...(last || {}), added };
}

export function deleteFowebPortalWatchMedia(id, index) {
  return apiRequest(`/fowebportalwatches/${id}/media/${index}`, { method: "DELETE" });
}
